<template>
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
  >
    <path d="M6.26765 11.793C5.96773 12.0787 5.49299 12.0672 5.2073 11.7672L0.205966 6.51678C-0.0699574 6.22711 -0.0699574 5.77187 0.205966 5.4822L5.2073 0.231735C5.49299 -0.0681872 5.96773 -0.0797238 6.26765 0.205968C6.56757 0.491659 6.57911 0.966392 6.29342 1.26631L1.78483 5.99949L6.29342 10.7327C6.57911 11.0326 6.56757 11.5073 6.26765 11.793Z" />
  </svg>
</template>
